module.exports = VueVideoPlayer;